import Loader from "components/Loader";
import { useEffect, useState } from "react";
import RadioButton from "../RadioButton";
import TextBox from "../TextBox";
import { Button } from "../Button";
import ShoppingCartService from "../services/shopping-cart.service";
import { useErrorBoundary } from "basket/ErrorBoundary";
import { SupplyOwnFabric } from "../SupplyOwnFabric";
import ProductQtyInput from "components/ProductQtyInput";
import { OtherFabricSelector } from "../OtherFabricSelector";
import InformationOverlay from "../InformationOverlay";
import useInfoIcons from "hooks/useInfoIcons";
import NumberInput from "../NumberInput";
import UnitConverter from "components/UnitConverter";
import Checkbox from "../Checkbox";
import { formatCurrency } from 'utils/utils';

export function BasketEditBedspreadsItem(props) {
    const { item, updateFabricItem, close } = props;
    const handleError = useErrorBoundary();
    const [metres, setMetres] = useState(item.fabric.fabricMetres.toFixed(1) + 'm');
    const [linings, setLinings] = useState([]);
    const [formData, setFormData] = useState({
        selectedLiningId: item.fabric.liningId,
        liningColour: item.fabric.liningColour,
        isPiping: item.fabric.isPiping,
        width: item.fabric.width,
        length: item.fabric.length,
        quantity: item.quantity,
        price: item.price,
        customization: item.fabric.customization,
        location: item.fabric.location,
        sessionId: item.productId,
        fabricId: item.fabricId,
        supplyOwnFabricNameOrDescription: item.supplyOwnFabricNameOrDescription,
        FabricRollWidth: item.supplyOwnFabricRollWidth,
        VerticalPatternRepeat: item.supplyOwnFabricPatternRepeat
    });

    const [measurementsChecked, setMeasurementsChecked] = useState(false)
    const [showMeasurementsCheckError, setShowMeasurementsCheckError] = useState(false)

    const [isSubmitDisabled, setSubmitDisabled] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [fabrics, setFabrics] = useState([])
    const [totalFabricsCount, setTotalFabricsCount] = useState(0)
    const [selectedFabric, setSelectedFabric] = useState(formData.fabricId)

    const [itemTitle, setItemTitle] = useState(`${item.fabric.fabricName} in ${item.colour || ''} Fabric by ${item.fabric.supplier.name || ''}`);;
    const title = () => item.supplyOwnFabric ? 'Edit Bedspreads in Supply Your Own Fabric' : `Edit Bedspreads - ${itemTitle}`;

    const infoIcons = useInfoIcons(item.productType);

    const handleInputChange = (field, value) => {
        setFormData((prevData) => {
            return {
                ...prevData,
                [field]: value,
            }
        });
    };

    const handleInputChangeUniversal = (e) => {
        const { name, value } = e.target;
        const updatedData = { ...formData, [name]: value };
        setFormData(updatedData);
    };

    const handleQuantityChange = (value) => handleInputChange('quantity', value);

    const createItem = () => {
        return {
            ...item,
            fabricId: selectedFabric,
            fabric: {
                fabricId: selectedFabric,
                liningId: formData.selectedLiningId,
                width: formData.width,
                length: formData.length,
                IsPiping: formData.isPiping,
                liningColour: formData.liningColour,
                Location: formData.location,
                customization: formData.customization,
                quantity: formData.quantity,
            },
            supplyOwnFabricNameOrDescription: formData.supplyOwnFabricNameOrDescription,
            supplyOwnFabricPatternRepeat: formData.VerticalPatternRepeat,
            supplyOwnFabricRollWidth: formData.FabricRollWidth
        }
    }

    const updatePrice = async () => {
        const item = createItem()

        setErrors([])

        if (item.supplyOwnFabric) {
            const isValidResponse = await fetch('/api/product/supply-own-fabric/validate', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify({
                    Description: item.supplyOwnFabricNameOrDescription,
                    VerticalPatternRepeat: Number(item.supplyOwnFabricPatternRepeat),
                    FabricRollWidth: Number(item.supplyOwnFabricRollWidth)
                })
            })

            if (isValidResponse.status !== 200) {
                const json = await isValidResponse.json();

                const lowercasedErrors = Object.entries(json).reduce((acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                }, {});

                setErrors(prev => ({
                    ...prev,
                    ...lowercasedErrors
                }));
            }
        }

        const response = await ShoppingCartService.create('price', createItem())
            .catch(_ => { handleError('Could not load item price. Please contact administrator'); });

        if (response) {
            setFormData((prevData) => {
                return {
                    ...prevData,
                    price: response.price * formData.quantity
                }
            });

            if (response.price > 0) {
                setSubmitDisabled(false);
            }

            setMetres(response.fabricMetres.toFixed(1) + 'm')
        }
    };

    const handlerMeasurementCheck = () => {
        setMeasurementsChecked(!measurementsChecked)
        setShowMeasurementsCheckError(false)
    }

    const handleUpdate = async () => {
        if (!measurementsChecked) {
            setShowMeasurementsCheckError(true)
            return
        }

        setLoading(true);
        await updateFabricItem(createItem());
        setLoading(false);
    }

    const fetchLinings = async () => {
        const response = await ShoppingCartService.get('linings?liningFor=4&liningType=1')
            .catch(error => { handleError('Could not load item details. Please contact administrator'); });
        if (response) setLinings(response);
    };

    const loadFabrics = async () => {
        setLoading(true)
        const response = await ShoppingCartService.get('same-fabrics?fabricId=' + formData.fabricId)
        setFabrics(response.fabrics)
        setTotalFabricsCount(response.totalCount)
        setLoading(false)
    }

    const loadAllFabrics = async () => {
        setLoading(true)
        const response = await ShoppingCartService.get('same-fabrics?fabricId=' + formData.fabricId + '&showAll=true')
        setFabrics(response.fabrics)
        setTotalFabricsCount(response.totalCount)
        setLoading(false)
    }

    const validatePrice = async (item, callback) => {
        fetch('/api/product/bedspreads/validate', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(item)
        })
            .then(response => {
                setErrors([]) // clear errors
                if (!response.ok) {
                    return response.json().then(err => { throw err });
                }
                return response.json();
            })
            .then(() => {
                callback(item);
            })
            .catch(jsonResponse => {
                const lowercasedErrors = Object.entries(jsonResponse).reduce((acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                }, {});

                setErrors(prevErrors => ({
                    ...prevErrors,
                    ...lowercasedErrors
                }));
            });
    }

    useEffect(() => {
        fetchLinings();
        loadFabrics();
    }, []);

    useEffect(() => {
        validatePrice(formData, updatePrice)
    }, [formData.selectedLiningId, formData.quantity]);

    useEffect(() => setSubmitDisabled(Object.keys(errors).length > 0), [errors])

    useEffect(() => {
        const foundFabric = fabrics.find(fabric => fabric.fabricId === selectedFabric);
        if (foundFabric) {
            setItemTitle(foundFabric.fullName);
            validatePrice(formData, updatePrice)
        }
    }, [selectedFabric]);

    return (
        <Loader isLoading={isLoading}>
            <form className="p-32 pb-54 bg3 measurements-change active-group sm-p-20">
                <div className="row">
                    <div className="col">
                        <div className="subtitle1 mb-16 sm-text-24 default-text">{title() + ' '}
                            {infoIcons && infoIcons.length > 0 && (
                                <span className="paragraph-info-icon-wrapper">
                                    <InformationOverlay item={infoIcons.find(o => o.name === "Description")} />
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="col-auto ps-24">
                        <span
                            className="curtains-icon curtains-icon-close size-24 show-btn hide-btn"
                            onClick={() => close()}></span>
                    </div>
                </div>

                {item.supplyOwnFabric && <SupplyOwnFabric fabricData={formData} errors={errors} handleInputChange={handleInputChangeUniversal} onBlur={() => validatePrice(formData, updatePrice)} />}
                {!item.supplyOwnFabric && <OtherFabricSelector fabrics={fabrics} totalFabricsCount={totalFabricsCount} loadAllFabrics={loadAllFabrics} selectedFabric={selectedFabric} setSelectedFabric={setSelectedFabric} />}

                <div>
                    <div className='row'>
                        <div className="col">
                            <div className="body-text3 gray mb-8">Measurements:</div>
                        </div>
                        <div className='col-auto'>
                            {infoIcons && infoIcons.length > 0 && (
                                <InformationOverlay item={infoIcons.find(o => o.name === "HowToMeasure")} clickTitle="How to Measure?" />
                            )}
                        </div>
                    </div>
                </div>

                <div className="row d-flex gap-40 mb-16 sm-gap-16">
                    <div className="col">
                        <div className="body-text3 mb-8">Width</div>
                        <NumberInput
                            name="width"
                            value={formData.width}
                            onChange={(e) => handleInputChange('width', e.target.value)}
                            onBlur={() => validatePrice(formData, updatePrice)}
                        />
                        {errors.Width && (
                            <span className="field-validation-error">{errors.Width}</span>
                        )}
                    </div>
                    <div className="col">
                        <div className="body-text3 mb-8">Length</div>
                        <NumberInput
                            name="length"
                            value={formData.length}
                            onChange={(e) => handleInputChange('length', e.target.value)}
                            onBlur={() => validatePrice(formData, updatePrice)}
                        />
                        {errors.Length && (
                            <span className="field-validation-error">{errors.Length}</span>
                        )}
                    </div>
                </div>

                <UnitConverter />

                {/* Linings */}
                <div className="body-text3 gray mb-8 align-center gap_3">Lining:
                    {infoIcons && infoIcons.length > 0 && (
                        <InformationOverlay item={infoIcons.find(o => o.name === "Lining")} />
                    )}
                </div>
                <div className="d-flex gap-32 row-gap-16 nowrap-labels mb-16 flex-wrap sm-two-columns">
                    {linings.map((lining) => (
                        <RadioButton
                            name="Lining"
                            label={lining.name}
                            value={lining.id}
                            checked={formData.selectedLiningId === lining.id}
                            onChange={() => handleInputChange('selectedLiningId', lining.id)}
                            key={lining.id}
                        />
                    ))}
                </div>
                <hr className="secondary-line mb-16"></hr>

                {/* Lining Colour */}
                {
                    formData.selectedLiningId != 7 &&
                    <div>
                        <div className="body-text3 gray mt-16 mb-16 align-center gap_3">Lining Colour:
                            {infoIcons && infoIcons.length > 0 && (
                                <InformationOverlay item={infoIcons.find(o => o.name === "LiningColour")} />
                            )}
                        </div>
                        <div className="d-flex gap-32 mb-16">
                            <RadioButton
                                name="liningColour"
                                label={'Ivory'}
                                value={0}
                                checked={formData.liningColour == 0}
                                onChange={() => handleInputChange('liningColour', 0)}
                            />
                            <RadioButton
                                name="liningColour"
                                label={'White'}
                                value={1}
                                checked={formData.liningColour == 1}
                                onChange={() => handleInputChange('liningColour', 1)}
                            />
                        </div>
                        <hr className="secondary-line mb-16" />
                    </div>
                }

                {/* Piping */}
                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Piping:
                        {infoIcons && infoIcons.length > 0 && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "Piping")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 mb-16">
                        <RadioButton
                            name="isPiping"
                            label={'Yes'}
                            value={1}
                            checked={formData.isPiping == true}
                            onChange={() => handleInputChange('isPiping', 1)}
                        />
                        <RadioButton
                            name="isPiping"
                            label={'No'}
                            value={0}
                            checked={formData.isPiping == false}
                            onChange={() => handleInputChange('isPiping', 0)}
                        />
                    </div>
                </div>
                <div className="dashed-line mb-16"></div>

                {/* Customization Section */}
                <div>
                    <div className="body-text3 gray mt-16 mb-16 align-center gap_3">Bedspread Customisation:</div>
                    <div className="max-width-410 mb-16 sm-text-14">If you have special requests, write below or <a href="/contact-us" className="underline">contact us</a> <a href="tel:0345 8620743" className="underline">0345 8620743</a>.</div>
                    <div className="mb-16">
                        <TextBox
                            name="Customization"
                            value={formData.customization}
                            placeholder="e.g. Trim or borders"
                            onChange={(e) => handleInputChange('customization', e.target.value)}
                            onBlur={() => validatePrice(formData, updatePrice)}
                        />
                    </div>
                    {errors.Customization && (
                        <span className="field-validation-error">{errors.Customization}</span>
                    )}
                </div>
                <div className="dashed-line"></div>

                {/* Location Section */}
                <div>
                    <div className="body-text3 gray mt-16 mb-16 align-center gap_3">Bedspread location:</div>
                    <div className="max-width-410 mb-16 sm-text-14">Let us know where your bedspread will be used, and we will include this in your order details.</div>
                    <div className="mb-16">
                        <TextBox
                            name="Location"
                            value={formData.location}
                            placeholder="e.g. Living room front window"
                            onChange={(e) => handleInputChange('location', e.target.value)}
                            onBlur={() => validatePrice(formData, updatePrice)}
                        />
                    </div>
                    {errors.Location && (
                        <span className="field-validation-error">{errors.Location}</span>
                    )}
                </div>

                <Checkbox
                    checked={measurementsChecked}
                    label={'I have checked all measurements'}
                    value={!measurementsChecked}
                    onChange={handlerMeasurementCheck}
                    requiredMessage={''}
                    name={'measurementsChecked'} />
                {showMeasurementsCheckError && <div className="text-danger m-8">Please confirm you have checked everything.</div>}

                {
                    item.supplyOwnFabric && 
                        <div>
                            <div className="body-text3 gray mt-32 mb-8 align-center gap_3">Quantity of fabric per item to be supplied by you:</div>
                            <TextBox name='sof-fabric-length' value={metres} className='max-width-150 mb-16' />
                        </div>
                }

                <div className="dashed-line mt-16"></div>

                {/* Total Price and Quantity */}
                <div>
                    <div className="subtitle2 mb-8 mt-16">TOTAL: <span className="body-text1">{formatCurrency(formData.price)}</span></div>
                    <div className="body-text6">Delivery for made-to-measure bedspreads: {item.deliveryContent} weeks.</div>
                </div>

                <div className="mb-16 mt-32" id="updateProductQuantity">
                    <div className="dashed-line mb-24"></div>
                    <div className="body-text3 gray mb-16">Quantity:</div>

                    <ProductQtyInput
                        digits={0}
                        initValue={formData.quantity}
                        onlyInt={true}
                        onChange={handleQuantityChange}
                        onBlur={() => validatePrice(formData, updatePrice)}
                    />
                    {errors.Quantity && (
                        <span className="field-validation-error">{errors.Quantity}</span>
                    )}
                </div>

                <div className="d-flex gap-16 mb-16 sm-column md-column sm-gap-8 sm-mb-0">
                    <div className="w-100 show-btn hide-btn">
                        <Button name="UPDATE" onClick={() => handleUpdate()} disabled={isSubmitDisabled || Object.keys(errors).length > 0} />
                    </div>
                </div>
            </form>
        </Loader>
    );
}